import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";

const breadcrumbsSlice = createSlice({
  name: "breadcrumbs",
  initialState: {
    currentBreadcrumbs: ["Home"],
  },
  //SHEP-82: These reducers methods can be imported to set the redux state from the components (any).
  reducers: {
    setBreadcrumbs: (state, action) => {
      const { currentBreadcrumbs } = action.payload;
      state.currentBreadcrumbs = currentBreadcrumbs;
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(getConnections.pending, (state, action) => {
  //       state.status = "loading";
  //     })
  //     .addCase(getConnections.rejected, (state, action) => {
  //       state.status = "failed";
  //       state.error = action.error.message;
  //     })
  //     .addCase(getConnections.fulfilled, (state, action) => {
  //       state.status = "loaded";
  //       state.connections = action.payload.data;
  //     });
  // },
});

//   export const getConnections = createAsyncThunk(
//     "connectionsBar/getConnections",
//     async (_, { getState }) => {
//       const state = getState();
//       const response = await axios.get("/connections/details");
//       return response;
//     }
//   );

//SHEP-82: These are some helper methods that can be easily used to read the redux state into any component that import this method.
export const selectBreadcrumbs = (state) =>
  state.tempInfo.breadcrumbs.currentBreadcrumbs;

export const { setBreadcrumbs } = breadcrumbsSlice.actions;

export default breadcrumbsSlice.reducer;
